/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-11 15:09:51
 * @LastEditTime: 2019-09-06 15:07:03
 * @LastEditors: Please set LastEditors
 */
const baseUrl = 'http://shtianye.oss-cn-shanghai.aliyuncs.com/img/'
export const imgURL = {
  baseUrl: baseUrl,
  bg: baseUrl + 'bg%402x.png',
  wxIcon: baseUrl + 'icon-WeChat%402x.png',
  banner: 'https://shtianye.oss-cn-shanghai.aliyuncs.com/img/banner/banner1.png',
  avatar: baseUrl + 'avatar.png',
  iconMore: baseUrl + 'shouye/more%403x.png',
  indexPageList: {
    '01': 'shouye/shucailei%403x.png',
    '02': 'shouye/rouqinlei%403x.png',
    '03': 'shouye/shuichanlei%403x.png',
    '04': 'shouye/shuiguolei%403x.png',
    '05': 'shouye/danpinlei%403x.png',
    '06': 'shouye/dongpinlei%403x.png',
    '07': 'shouye/douzhipinlei%403x.png',
    '08': 'shouye/liangyoulei%403x.png',
    '09': 'shouye/mimianzhipinlei%403x.png',
    '10': 'shouye/nanbeiganhuolei%403x.png',
    '11': 'shouye/tiaoweipinlei%403x.png',
    '12': 'shouye/xiuxianshipinruyinlei%403x.png',
    '13': 'shouye/riyongpin%403x.png'
  },
  categoryPageList: {
    '01': 'fenlei/shucailei%403x.png',
    '02': 'fenlei/rouqinlei%403x.png',
    '03': 'fenlei/shuichanlei%403x.png',
    '04': 'fenlei/shuiguolei%403x.png',
    '05': 'fenlei/danpinlei%403x.png',
    '06': 'fenlei/dongpinlei%403x.png',
    '07': 'fenlei/douzhipinlei%403x.png',
    '08': 'fenlei/liangyoulei%403x.png',
    '09': 'fenlei/mimianzhipinlei%403x.png',
    '10': 'fenlei/nanbeiganhuolei%403x.png',
    '11': 'fenlei/tiaoweipinlei%403x.png',
    '12': 'fenlei/xiuxianshipinruyinlei%403x.png',
    '13': 'fenlei/riyongpin%403x.png',
    '14': 'fenlei/qita%403x.png'
  },
  indexPageLists: [
  'shouye/shucailei%403x.png',
  'shouye/rouqinlei%403x.png',
  'shouye/shuichanlei%403x.png',
  'shouye/shuiguolei%403x.png',
  'shouye/danpinlei%403x.png',
  'shouye/dongpinlei%403x.png',
  'shouye/douzhipinlei%403x.png',
  'shouye/liangyoulei%403x.png',
  'shouye/mimianzhipinlei%403x.png',
  'shouye/nanbeiganhuolei%403x.png',
  'shouye/tiaoweipinlei%403x.png',
  'shouye/xiuxianshipinruyinlei%403x.png',
  'shouye/riyongpin%403x.png',
  'fenlei/qita%403x.png',
  'fenlei/qita%403x.png',
  'fenlei/qita%403x.png',
  'fenlei/qita%403x.png'

  ],
  categoryPageLists: [
   'fenlei/shucailei%403x.png',
   'fenlei/rouqinlei%403x.png',
   'fenlei/shuichanlei%403x.png',
   'fenlei/shuiguolei%403x.png',
   'fenlei/danpinlei%403x.png',
   'fenlei/dongpinlei%403x.png',
   'fenlei/douzhipinlei%403x.png',
   'fenlei/liangyoulei%403x.png',
   'fenlei/mimianzhipinlei%403x.png',
   'fenlei/nanbeiganhuolei%403x.png',
   'fenlei/tiaoweipinlei%403x.png',
   'fenlei/xiuxianshipinruyinlei%403x.png',
   'fenlei/riyongpin%403x.png',
   'fenlei/qita%403x.png',
   'fenlei/qita%403x.png',
   'fenlei/qita%403x.png',
   'fenlei/qita%403x.png',
   'fenlei/qita%403x.png',
   'fenlei/qita%403x.png',
   'fenlei/qita%403x.png',
   'fenlei/qita%403x.png',
   'fenlei/qita%403x.png',
   'fenlei/qita%403x.png'
  ]
}